<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 11 11"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M9.476 5.5c0-.187-.016-.363-.038-.539l1.16-.907a.277.277 0 0 0 .066-.352l-1.1-1.903a.276.276 0 0 0-.335-.121l-1.37.55a4.018 4.018 0 0 0-.93-.54L6.722.232A.268.268 0 0 0 6.45 0h-2.2a.268.268 0 0 0-.27.231l-.208 1.458a4.226 4.226 0 0 0-.93.539l-1.37-.55a.268.268 0 0 0-.335.12l-1.1 1.904a.271.271 0 0 0 .066.352l1.16.907a4.362 4.362 0 0 0-.038.539c0 .182.017.363.039.539l-1.16.908a.277.277 0 0 0-.067.352l1.1 1.903c.066.12.215.165.336.12l1.37-.55c.285.22.593.402.929.54l.209 1.457a.268.268 0 0 0 .27.231h2.2a.268.268 0 0 0 .269-.231l.209-1.457c.335-.138.643-.325.93-.54l1.369.55c.126.05.27 0 .335-.12l1.1-1.903a.277.277 0 0 0-.066-.352l-1.16-.908c.022-.176.038-.352.038-.539zM5.351 7.425A1.927 1.927 0 0 1 3.426 5.5c0-1.061.864-1.925 1.925-1.925 1.062 0 1.925.864 1.925 1.925a1.927 1.927 0 0 1-1.925 1.925z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
